/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AdvancedSearchType} from '../models/AdvancedSearchType';
import type {AlertAvailableOption} from '../models/AlertAvailableOption';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';
import type {SavedListType} from '../models/SavedListType';

export interface GetAlertContentAvailableOptions$Request {
    userId: number;
}

export interface GetAlertContentAvailableOptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAlertContentAvailableOptionsRequest = createAction<PayloadData<void, GetAlertContentAvailableOptions$Request>>('ALERT_AVAILABLE_OPTIONS__GET_ALERT_CONTENT_AVAILABLE_OPTIONS__REQUEST');
export const getAlertContentAvailableOptionsSuccess = createAction<PayloadData<Array<DictionaryItem>, GetAlertContentAvailableOptions$Request>>('ALERT_AVAILABLE_OPTIONS__GET_ALERT_CONTENT_AVAILABLE_OPTIONS__SUCCESS');
export const getAlertContentAvailableOptionsFailure = createAction<PayloadData<Error, GetAlertContentAvailableOptions$Request, true>>('ALERT_AVAILABLE_OPTIONS__GET_ALERT_CONTENT_AVAILABLE_OPTIONS__FAILURE');

export const getAlertContentAvailableOptionsActions = [
    getAlertContentAvailableOptionsRequest,
    getAlertContentAvailableOptionsSuccess,
    getAlertContentAvailableOptionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAlertContentAvailableOptions = (meta: GetAlertContentAvailableOptions$Request, config?: GetAlertContentAvailableOptions$Config) => {
    return {
        CALL_API: {
            types: getAlertContentAvailableOptionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/alerts/available-options`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSavedListAvailableOptions$Request {
    userId: number;
    savedListType: SavedListType;
}

export interface GetSavedListAvailableOptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSavedListAvailableOptionsRequest = createAction<PayloadData<void, GetSavedListAvailableOptions$Request>>('ALERT_AVAILABLE_OPTIONS__GET_SAVED_LIST_AVAILABLE_OPTIONS__REQUEST');
export const getSavedListAvailableOptionsSuccess = createAction<PayloadData<AlertAvailableOption, GetSavedListAvailableOptions$Request>>('ALERT_AVAILABLE_OPTIONS__GET_SAVED_LIST_AVAILABLE_OPTIONS__SUCCESS');
export const getSavedListAvailableOptionsFailure = createAction<PayloadData<Error, GetSavedListAvailableOptions$Request, true>>('ALERT_AVAILABLE_OPTIONS__GET_SAVED_LIST_AVAILABLE_OPTIONS__FAILURE');

export const getSavedListAvailableOptionsActions = [
    getSavedListAvailableOptionsRequest,
    getSavedListAvailableOptionsSuccess,
    getSavedListAvailableOptionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {SavedListType} meta.savedListType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSavedListAvailableOptions = (meta: GetSavedListAvailableOptions$Request, config?: GetSavedListAvailableOptions$Config) => {
    return {
        CALL_API: {
            types: getSavedListAvailableOptionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/saved-lists/${meta.savedListType}/available-options`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetSavedSearchAvailableOptions$Request {
    userId: number;
    advancedSearchType: AdvancedSearchType;
}

export interface GetSavedSearchAvailableOptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSavedSearchAvailableOptionsRequest = createAction<PayloadData<void, GetSavedSearchAvailableOptions$Request>>('ALERT_AVAILABLE_OPTIONS__GET_SAVED_SEARCH_AVAILABLE_OPTIONS__REQUEST');
export const getSavedSearchAvailableOptionsSuccess = createAction<PayloadData<AlertAvailableOption, GetSavedSearchAvailableOptions$Request>>('ALERT_AVAILABLE_OPTIONS__GET_SAVED_SEARCH_AVAILABLE_OPTIONS__SUCCESS');
export const getSavedSearchAvailableOptionsFailure = createAction<PayloadData<Error, GetSavedSearchAvailableOptions$Request, true>>('ALERT_AVAILABLE_OPTIONS__GET_SAVED_SEARCH_AVAILABLE_OPTIONS__FAILURE');

export const getSavedSearchAvailableOptionsActions = [
    getSavedSearchAvailableOptionsRequest,
    getSavedSearchAvailableOptionsSuccess,
    getSavedSearchAvailableOptionsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {AdvancedSearchType} meta.advancedSearchType
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSavedSearchAvailableOptions = (meta: GetSavedSearchAvailableOptions$Request, config?: GetSavedSearchAvailableOptions$Config) => {
    return {
        CALL_API: {
            types: getSavedSearchAvailableOptionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/saved-searches/${meta.advancedSearchType}/available-options`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

